import script from "./CurrencyFlag.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrencyFlag.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__